const BeingExpo={
    "projectname" : "Stall ",
    "description" : "",
    "uid" : "lqGVe2nrnqX7oWb4RpnPUrVz5GA3",
    "views" : 0,
    "stars" : 0,
    "fontColor" : "white",
    "splashOpacity" : "0.5",
    "splashColor2" : "15, 65, 209",
    "splashColor1" : "11, 242, 245",
    "isCenterPosition" : true,
    "isSceneRotation" : true,
    "fov" : 70,
    "isSplashEnabled" : true,
    "sceneRotationTime" : 45,
    "interactionType" : "reticle",
    "uiContainer" : {
        "gyroMode" : true,
        "projectName" : true,
        "signIn" : true,
        "vrMode" : true,
        "like" : true,
        "share" : true,
        "home" : true,
        "melzoLogo" : true
    },
    "scrolling" : {
        "vertical" : true,
        "horizontal" : true
    },
    "reticleProperties" : {
        "size" : 0.08,
        "color" : "white"
    },
    "isInteractionEnabled" : true,
    "isPositionUpdated" : false,
    "version" : 564,
    "projectCategory" : [],
    "assetModels" : [],
    "assetDocuments" : [],
    "assetBgVideos" : [],
    "assetBgGifs" : [],
    "assetBgImages" : [ 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/73a82894-cd1f-e39f-4eff-ac0d558401d1.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/6d4a4846-8bad-2481-ec8c-0023905865fb.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/810b1de4-1ce7-c866-daa8-dadd4626fafa.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/4bdb99c4-b610-2873-996b-b07f4e461e84.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/8377cda8-85b4-f43b-2a97-0b918ac5d553.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/50b815ed-b676-6a63-4f25-738de86ab97c.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/7d4364a3-d012-6ccb-f160-95b19c517cda.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/ae040ddf-42fb-08ae-a7a5-7b27cdb05e8a.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/b2f8309b-ae3a-4cfe-3fd5-1ca7116fb504.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/091c2b30-1ff4-dcc9-0e22-d4bc4a4f9186.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/a8f892be-9b8c-6024-f368-19cd18b9028b.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/ada7e8a7-9df6-1bbf-b97c-ef8403ca9a2c.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/8018642f-b49a-0fac-0c74-e935d8dc51e8.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/e25eba71-344a-c6ad-afbf-342ef115a4ae.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/b44a0090-96cc-31f6-303a-31d2d110b6f1.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/1c1e86da-9bfd-1218-59ad-57df4636edca.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/c06d1d58-d2d3-b590-5b44-ac7f198a7ede.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/b0955576-9546-9c2e-5f27-714b6fd4bc6b.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/76eadf2a-3a17-7c5f-5e6f-da41f8bc7cef.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/d268c403-46ae-10ea-d99b-ccd6d3a627fd.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/6625fbbf-9cf0-d160-ec9a-c96ccc3553e1.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/df6c07f7-96ce-62a8-0fa9-163484d94ff8.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/6a6d4128-cd35-2273-8082-217ec75ebe67.jpg"
    ],
    "assetVideos" : [ 
        "video/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetvideo/a0be2c14-ed08-878d-758a-ce9949780b7b.mp4"
    ],
    "assetSounds" : [],
    "assetGifs" : [],
    "assetImages360View" : [],
    "assetImages" : [ 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/8ce2c0e4-23df-ed01-467b-523bcd4dc88b.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/0cf536a1-1cfa-e001-54a4-284180157cbf.png", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/196342f4-2de1-eea8-ad63-764ce67ed6ee.png", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/b19776e9-b764-9f1b-7fdc-ff4c10362547.png", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/5f2e94a5-411f-4a5a-7eca-696d722bca99.png", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/7b39d3cb-3f5d-031c-0faf-089093e48b80.png", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/a10739af-51cb-05bc-529f-2729047f7382.png", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/1bdcb71a-3bde-1f98-1271-42c8d89003da.png", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/3fcbcb89-61f0-b3dc-c506-1a311feb6c57.png", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/efb64bc5-7764-64cb-5fea-92b5b5eec672.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/d8ce00bc-2581-a246-d499-d1a8b88d1347.jpeg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetgif/0157cc0b-a8e1-b823-cf93-605b7c8803aa.gif", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/0e281cd7-0433-5c8a-6209-abaffaa79c84.jpg", 
        "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/dab540d9-7c58-fc63-60f9-8ddeff8fa9f4.png"
    ],
    "starredby" : [],
    "isEnabled" : true,
    "featured" : false,
    "loginSceneNumberPostMaxProjectView" : 2,
    "checkProjectViewIn" : "last15Days",
    "maxProjectViewBeforeSignIn" : 3,
    "loginSceneNumber" : 1,
    "isLoginNeeded" : false,
    "planType" : "FREE",
    "sound" : {
        "enable" : false,
        "volume" : 1,
        "src" : "sound/public/sound-80kb.mp3",
        "_id" : "2452a038-8aa6-9632-b376-82cb12a51b42"
    },
    "navMenu" : {
        "cells" : [],
        "theme" : {
            "linear" : {
                "scale" : {
                    "z" : 1,
                    "y" : 1,
                    "x" : 1
                },
                "margin" : {
                    "right" : 0,
                    "left" : 2,
                    "bottom" : 0,
                    "top" : 0
                },
                "type" : "linear"
            }
        },
        "homeLogo" : {
            "posIndex" : 0,
            "src" : "",
            "_id" : "asdfad-456879-456789123333a-zcvczv"
        },
        "enabled" : true
    },
    "projects" : [],
    "scenes" : [ 
        {
            "sceneid" : "2426d2c0-300d-d8fb-1721-f7467568e593",
            "bgimage" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/image360/6a6d4128-cd35-2273-8082-217ec75ebe67.jpg",
            "srcType" : "bgImage",
            "audiopa" : [],
            "menu3ds" : [],
            "documents" : [],
            "gltfmodels" : [],
            "carousels" : [],
            "grids" : [],
            "fixedtextarray" : [],
            "imagepopups" : [],
            "popups" : [],
            "videos" : [ 
                {
                    "position" : "-1.3919631316982994 2.2590212931722204 -13.193540137124195",
                    "src" : "video/public/video2d/334ecc46-4063-43b4-9a34-37ce1a8658ef.mp4",
                    "height" : "3.0574085860948745",
                    "width" : "5.983184210699563",
                    "scale" : "1",
                    "depth" : "20",
                    "opacity" : "1",
                    "loop" : false,
                    "videoLock" : false,
                    "enablePopup" : true,
                    "volume" : 1,
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "esol_temp" : [],
                    "autoPlay" : true,
                    "videoType" : "normal",
                    "name" : "videopanel"
                }
            ],
            "sounds" : [],
            "gifs" : [ 
                {
                    "position" : "6.291114305999076 2.5624903652803273 -14.790155773026182",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetgif/0157cc0b-a8e1-b823-cf93-605b7c8803aa.gif",
                    "height" : "2.1645839136534626",
                    "width" : "4.4204400196474065",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "noOfFrames" : "10",
                    "loops" : "1",
                    "startFrame" : "1",
                    "enablePopup" : false,
                    "playMode" : "hoverplay",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "clickInBeginning" : false,
                    "playerId" : "",
                    "isPlayerGif" : false,
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "logo_gif"
                }
            ],
            "images360view" : [],
            "images" : [ 
                {
                    "position" : "-6.730481059617782 -0.9863800299257791 -18.80764948478916",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/d8ce00bc-2581-a246-d499-d1a8b88d1347.jpeg",
                    "height" : "1.0898907303821352",
                    "width" : "1.987214552053263",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "desk_logo"
                }, 
                {
                    "position" : "-10.32788490770461 3.5906447867782325 -16.74640449017011",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/932f8ea3-1a2b-bdff-1c52-397fe738ca30.png",
                    "height" : "0.9809614155802451",
                    "width" : "0.8838301070064855",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "whatsapp"
                }, 
                {
                    "position" : "-9.285314537862044 1.7778940141456745 -17.624472383802946",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/3fcbcb89-61f0-b3dc-c506-1a311feb6c57.png",
                    "height" : "0.9255968767542448",
                    "width" : "0.8629697277382395",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "contactno"
                }, 
                {
                    "position" : "-9.262268827380185 3.4872719317076872 -17.3795658934182",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/a10739af-51cb-05bc-529f-2729047f7382.png",
                    "height" : "1.063501116519288",
                    "width" : "0.9730412822229965",
                    "scale" : "1",
                    "isTargetEnabled" : true,
                    "target" : "https://beingexporter.com/",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "website"
                }, 
                {
                    "position" : "-9.324873120095955 -0.11261748819905579 -17.692768539588812",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/1bdcb71a-3bde-1f98-1271-42c8d89003da.png",
                    "height" : "0.8305319804518905",
                    "width" : "0.720891361126914",
                    "scale" : "1",
                    "isTargetEnabled" : true,
                    "target" : "melzounite",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "videocall"
                }, 
                {
                    "position" : "-11.415291625232646 3.645365879023844 -16.01257083415846",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/81a26385-44a6-fb9b-660b-ae51858545d1.png",
                    "height" : "0.9178679302672583",
                    "width" : "0.8931343277517948",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "facebook"
                }, 
                {
                    "position" : "-11.565054111429037 1.7585916190516149 -16.22211080337943",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/7b39d3cb-3f5d-031c-0faf-089093e48b80.png",
                    "height" : "0.9051791988930944",
                    "width" : "0.97231755727245",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "twitter"
                }, 
                {
                    "position" : "-11.49325158283183 -0.19633773081917977 -16.36663128286302",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/5f2e94a5-411f-4a5a-7eca-696d722bca99.png",
                    "height" : "0.9006325184570247",
                    "width" : "0.8801888180103165",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "instagram"
                }, 
                {
                    "position" : "-10.420125138749452 1.727526368196344 -16.983422645037955",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/196342f4-2de1-eea8-ad63-764ce67ed6ee.png",
                    "height" : "1.0530473043825226",
                    "width" : "0.9040365826452241",
                    "scale" : "1",
                    "isTargetEnabled" : true,
                    "target" : "https://www.youtube.com/watch?v=64gQdnVP6f0",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "youtube"
                }, 
                {
                    "position" : "-10.362488698491774 -0.14822565579149571 -17.10546278615681",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/b19776e9-b764-9f1b-7fdc-ff4c10362547.png",
                    "height" : "0.8987756348729345",
                    "width" : "0.8480954367046889",
                    "scale" : "1",
                    "isTargetEnabled" : true,
                    "target" : "https://www.linkedin.com/checkpoint/challengesV2/AQEoGrnIiHl62AAAAXb2vyStR7f63WwbRg7Gut3ZSVZOanK4R3PPq4HPhWGR_XuqNckUrdB8DA-_nVAgwEVkB3J4zSKuDvE1MA?original_referer=https%3A%2F%2Fwww.google.com%2F",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "linkedin"
                }, 
                {
                    "position" : "13.296641919256299 4.607385423594212 -14.21166117065587",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/0e281cd7-0433-5c8a-6209-abaffaa79c84.jpg",
                    "height" : "1.8803891305865403",
                    "width" : "3.4064936273701223",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "address_text"
                }, 
                {
                    "position" : "13.58792653667744 2.0961430382639477 -14.524959097945668",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/0e281cd7-0433-5c8a-6209-abaffaa79c84.jpg",
                    "height" : "2.043666820525015",
                    "width" : "3.408676987231085",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "description_text"
                }, 
                {
                    "position" : "-17.55192370272248 3.1506963563679142 -9.055555576759438",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/efb64bc5-7764-64cb-5fea-92b5b5eec672.jpeg",
                    "height" : "8.534084895299339",
                    "width" : "11.0182597948183",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : true,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "imagepanel5"
                }, 
                {
                    "position" : "18.77199621157175 3.22395100541438 -6.100680138101281",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/efb64bc5-7764-64cb-5fea-92b5b5eec672.jpeg",
                    "height" : "9.06469395118395",
                    "width" : "12.962190949817066",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : true,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "imagepanel1"
                }, 
                {
                    "position" : "15.794862635533873 3.1856124104971673 11.847961339179934",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/efb64bc5-7764-64cb-5fea-92b5b5eec672.jpeg",
                    "height" : "8.90462688637177",
                    "width" : "14.457257118185698",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : true,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "imagepanel2"
                }, 
                {
                    "position" : "-9.93443967214295 3.276005466492956 17.04625168722029",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/efb64bc5-7764-64cb-5fea-92b5b5eec672.jpeg",
                    "height" : "8.734084895299336",
                    "width" : "11.785095455594915",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : true,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "imagepanel3"
                }, 
                {
                    "position" : "-18.856143409368094 3.1918907485489276 5.853006849019737",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/efb64bc5-7764-64cb-5fea-92b5b5eec672.jpeg",
                    "height" : "8.67393345940489",
                    "width" : "11.843773434857246",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : true,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "imagepanel4"
                }, 
                {
                    "position" : "-15.475970659656715 2.924265511889788 12.326516270115274",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/dab540d9-7c58-fc63-60f9-8ddeff8fa9f4.png",
                    "height" : "2",
                    "width" : "2.7964089962546517",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "download_brochure3"
                }, 
                {
                    "position" : "-19.715660110848688 2.7752933249820027 -1.8948597187655372",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/dab540d9-7c58-fc63-60f9-8ddeff8fa9f4.png",
                    "height" : "2",
                    "width" : "2.7964089962546517",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "download_brochure4"
                }, 
                {
                    "position" : "-13.307818141450102 2.7389035438553893 -14.67652491877924",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/dab540d9-7c58-fc63-60f9-8ddeff8fa9f4.png",
                    "height" : "2",
                    "width" : "2.7964089962546517",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "download_brochure5"
                }, 
                {
                    "position" : "19.5769479670222 2.8115205877760374 2.9729548064201836",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/dab540d9-7c58-fc63-60f9-8ddeff8fa9f4.png",
                    "height" : "2",
                    "width" : "2.7964089962546517",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "download_brochure1"
                }, 
                {
                    "position" : "8.39434920771457 2.942176829182034 17.913081724950796",
                    "src" : "image/private/lqGVe2nrnqX7oWb4RpnPUrVz5GA3/5ff424255b7a060018dbeb03/widgetimage/dab540d9-7c58-fc63-60f9-8ddeff8fa9f4.png",
                    "height" : "2",
                    "width" : "2.7964089962546517",
                    "scale" : "1",
                    "isTargetEnabled" : false,
                    "target" : "UNKNOWN",
                    "depth" : "20",
                    "opacity" : "1",
                    "enablePopup" : false,
                    "animation" : "none",
                    "persistent" : {
                        "excludeFrom" : [],
                        "isEnabled" : false
                    },
                    "triggerTheta" : 60,
                    "vicinityEnabled" : false,
                    "name" : "download_brochure2"
                }
            ],
            "switchbuttons" : [],
            "homeMenuEnabled" : true,
            "arModelSrc" : ""
        }
    ],
    "projecttype" : "general",
    "shortnerUrl" : ""
}
export default BeingExpo